export { default as VoloFitnessLogo } from './VoloFitnessLogo';
export { default as VoloFitnessLogoBarbell } from './VoloFitnessLogoBarbell';
export { default as VoloPassBadgeIcon } from './VoloPassBadgeIcon';
export { default as VoloPassLogo } from './VoloPassLogo';
export { default as VoloPassYellowBadge } from './VoloPassYellowBadge/VoloPassYellowBadge';
